import React, { useEffect, useState } from "react";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  PickerSelectSimple,
  ModalBase,
} from "@reusejs/react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentBranch,
  clearBankerAuth,
  clearBankerRedirectUrl,
} from "store";
import { getTeams, getBankBranchesByid } from "services";
import BankConfirmationModal from "./BankConfirmationModal";

export default function BranchForm(props: any) {
  const router = useRouter();
  const dispatch = useDispatch();
  const form = useBetaForm({
    current_branch: "",
  });

  const bank = useSelector((state: any) => {
    return state.bankerAuth.bank;
  });
  const redirectUrl = useSelector((state: any) => {
    return state.bankerAuth?.redirectUrl;
  });

  const form_constraints = {
    current_branch: {
      presence: {
        allowEmpty: false,
        message: "^Branch can't be blank",
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const handleSubmit = async () => {
    try {
      if (form.validate()) {
        dispatch(setCurrentBranch(form.value.current_branch));
        if (redirectUrl) {
          router.push(redirectUrl);
          dispatch(clearBankerRedirectUrl());
        } else {
          router.push("/");
        }
      }
    } catch (error: any) {
      console.log("check here error", error);
    }
  };

  const getBankBranches = async () => {
    const data: any = await getTeams();
    const branches: any = await Promise.all(
      data.map(async (item: any) => {
        if (item["teams*tenant"] === "bank-branch") {
          const branchIdData: any = await getBankBranchesByid([
            item["teams*name"],
          ]);
          if (branchIdData.length > 0) {
            const branchData = branchIdData[0];
            return { ...branchData, ...{ team: item } };
          }
        }
      })
    );

    const filteredBranches: any = branches.filter((item: any) => item && item);

    const filteredData =
      filteredBranches.length > 0 &&
      filteredBranches.map((item: any) => {
        return { value: item.uuid, label: item.name, team: item.team };
      });

    if (!filteredData) {
      openModal(
        "Not Authorised",
        "You are not authorised to access this dashboard, please verify the dashboard url in invitation email.",
        "bg-red-50 text-red-500"
      );
      handleLogout();
    }

    return filteredData;
  };

  const handleLogout = () => {
    dispatch(clearBankerAuth());
    router.push("/login");
  };
  const openModal = async (title: string, message: string, color: string) => {
    const BankConfirmationModalWrapper = (props: any) => {
      return (
        <BankConfirmationModal
          heading={title}
          description={message}
          color={color}
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content: BankConfirmationModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "sm:my-8 sm:w-full sm:max-w-md",
        },
      },
      1000,
      "__next"
    );
  };

  return (
    <div className="mt-6">
      <div className="mb-[44px]">
        <p className="text-3xl font-sans font-normal">Get Started Now</p>
        <p className="font-sans text-xs mt-1 mb-16">
          Enter your details to access your account
        </p>
        <PickerSelectSimple
          refresh={bank}
          dataSource={async (c) => {
            return await getBankBranches();
          }}
          defaultSelected={
            form.getField("current_branch") !== ""
              ? [form.getField("current_branch")]
              : []
          }
          onChange={(value: any) => form.setField("current_branch", value)}
          error={
            form.errors.get("current_branch") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("current_branch")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={false}
        />
      </div>
      <ButtonBase
        variant="primary"
        label="Get Started"
        onClick={handleSubmit}
        buttonBaseClasses={{
          font: "text-sm font-medium",
          backgroundColor: " hover:bg-[#3a3a3a]",
          textColor: "text-white",
          border: "any",
          width: "w-full",
          padding: "px-4 py-3",
          borderRadius: "rounded-xl",
        }}
      />
      <hr style={{ marginTop: "71px", marginBottom: "24px" }} />
      <p className="font-sans text-xs text-center mb-[103px]">
        By logging in, I agree to the{" "}
        <span className="underline font-sans">
          Privacy policy & terms and conditions
        </span>
      </p>
    </div>
  );
}
